export const formatPreFinanceDisplayCode = ({ preFinanceId, preFinanceCode, isLegacy }) => {
  if (!preFinanceId || preFinanceId <= 0) {
    return "";
  }

  if (isLegacy) {
    return `LEGACY-${preFinanceId}`;
  }

  if (preFinanceCode) {
    return preFinanceCode;
  }

  return `#${preFinanceId}`;
};

export const mapPreFinanceReadToOverviewRow = (dto) => {
  if (!dto) {
    return null;
  }

  return {
    preFinanceId: dto.preFinanceId,
    entityId: dto.entityId,
    preFinanceCode: dto.preFinanceCode,
    preFinanceType: dto.preFinanceType,
    version: dto.version,
    productLabel: dto.preFinanceType === 0 ? "VAT" : dto.preFinanceType === 1 ? "Excise" : "—",
    countryId: dto.countryId,
    year: dto.year,
    startMonth: dto.startMonth,
    endMonth: dto.endMonth,
    periodType: dto.periodType,
    claimId: dto.claimId,
    claimCode: dto.claimCode,
    claimStateId: dto.claimStateId,
    refundAmount: dto.refundAmount,
    declarationAmount: dto.declarationAmount,
    totalCosts: dto.totalCosts,
    payoutAmount: dto.payoutAmount,
    calculatedPayoutAmount: dto.calculatedPayoutAmount,
    payoutAdjustmentReason: dto.payoutAdjustmentReason,
    isFinalized: dto.payedOut === 1,
    payoutDate: dto.payedOut === 1 ? dto.payoutDate : null,
    creationDate: dto.creationDate,
    linkedInvoiceCount: dto.linkedInvoiceCount,
    linkedExciseClaimCount: dto.linkedExciseClaimCount,
    isLegacy: dto.isLegacy,
    legacyMismatchReason: dto.legacyMismatchReason,
  };
};
